<template>
  <div class="activityDetail">
    <div class="problemContainer">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="base">
          <template #title>
            <span>
              <img src="../../assets/svg/bsaicIcon.svg" alt="" />
              基本信息
            </span>
          </template>
          <el-descriptions :column="3" border>
            <el-descriptions-item label="活动索赔单号">{{
              detailData.claimStatementNum
            }}</el-descriptions-item>
            <el-descriptions-item label="活动名称">{{
              detailData.activityName
            }}</el-descriptions-item>
            <el-descriptions-item label="币种">{{
              detailData.currency == 0 ? "CNY" : detailData.currency == 1 ? "USD" : detailData.currency == 2 ? "EUR" : "GBP"
            }}</el-descriptions-item>
            <el-descriptions-item label="状态">
              <span :class="'status' + detailData.status">
                {{ getStatus(detailData.status) }}
              </span></el-descriptions-item
            >
            <el-descriptions-item label="提交时间">
              {{
                detailData.createTime
                  ? detailData.createTime.replace("T", " ")
                  : ""
              }}
            </el-descriptions-item>
            <el-descriptions-item label="国家">{{
              detailData.countryName
            }}</el-descriptions-item>
            <el-descriptions-item label="客户账号">{{
              detailData.customerAccount
            }}</el-descriptions-item>
            <el-descriptions-item label="客户名称" :span="2">{{
              detailData.customerName
            }}</el-descriptions-item>
            <el-descriptions-item label="活动描述" :span="3">{{
              detailData.activityDescription
            }}</el-descriptions-item>
          </el-descriptions>
        </el-collapse-item>
      </el-collapse>
      <el-collapse v-model="activeNames">
        <el-collapse-item name="car">
          <template #title>
            <span>
              <img src="../../assets/svg/carInfo.svg" alt="" />
              车辆信息
            </span>
          </template>
          <el-table
            :data="detailData.vehicleList"
            border
            stripe
            highlight-current-row
            max-height="450"
          >
            <el-table-column
              type="index"
              label="序号"
              width="60"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="vin"
              label="VIN"
              min-width="180"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="carBrand"
              label="品牌"
              min-width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="carModel"
              label="车型"
              min-width="150"
              align="center"
            >
              <template slot-scope="scope">
                <el-input
                  v-if="mode === 'audit'"
                  v-model="scope.row.carModel"
                  size="mini"
                  placeholder="请输入车型"
                ></el-input>
                <span v-else>{{ scope.row.carModel }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="carAttribute"
              label="车辆属性"
              min-width="100"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.carAttribute === 0">燃油车</span>
                <span v-else-if="scope.row.carAttribute === 1">电动车</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="productionDate"
              label="生产日期"
              min-width="120"
              align="center"
            >
              <template slot-scope="scope">
                {{
                  scope.row.productionDate
                    ? scope.row.productionDate.replace("T", " ")
                    : "-"
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="activityAmount"
              label="活动金额"
              min-width="100"
              align="center"
            >
              <template slot-scope="scope">
                {{
                  scope.row.activityAmount || detailData.activityAmount || "-"
                }}
              </template>
            </el-table-column>
            <el-table-column label="附件" min-width="340">
              <template slot-scope="scope">
                <file-upload-list
                  ref="fileUploadList"
                  :fileList="scope.row.fileList"
                ></file-upload-list>

                <!-- <div
                class="file-thumbnails"
                v-if="scope.row.fileList && scope.row.fileList.length > 0"
              >
                <div
                  v-for="(file, index) in scope.row.fileList.slice(0, 1)"
                  :key="index"
                  class="thumbnail-item"
                  @click="handlePreviewFile(scope.row.fileList, index)"
                >
                  <img
                    v-if="getFileIcon(file)"
                    :src="getFileIcon(file)"
                    alt=""
                  />
                  <span class="file-name" :title="file.name || file.fileName">
                    {{ (file.name || file.fileName || "").substring(0, 8) }}...
                  </span>
                </div>
                <div v-if="scope.row.fileList.length > 1" class="more-files">
                  +{{ scope.row.fileList.length - 1 }}
                </div>
              </div>
              <span v-else>-</span> -->
              </template>
            </el-table-column>
          </el-table>
          <div class="total-row">
            <span>VIN数量: {{ vinCount }}</span>
            <span style="margin-left: 30px">总金额: {{ totalAmount }}</span>
          </div>
        </el-collapse-item>
      </el-collapse>
      <el-collapse v-model="activeNames" v-if="mode === 'audit'">
        <el-collapse-item name="operation">
          <template #title>
            <span>
              <img src="../../assets/svg/approvalOperation.svg" alt="" />
              审批操作
            </span>
          </template>
          <div v-if="mode === 'audit'">
            <el-button class="lang-but" type="primary" @click="handleAuditPass"
              >通过</el-button
            >
            <el-button class="lang-but" type="danger" @click="handleAuditReject"
              >驳回</el-button
            >
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>

    <el-dialog
      width="600px !important"
      title="审核驳回"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="rejectFormRef"
        label-width="85px"
      >
        <el-form-item label="驳回原因" prop="rejectReason">
          <el-input
            v-model="form.rejectReason"
            type="textarea"
            placeholder="请输入驳回原因"
            :autosize="{ minRows: 4, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <div class="submitArea">
          <el-button type="primary" @click="auditRejectSubmit()"
            >提交</el-button
          >
          <el-button plain @click="dialogVisible = false">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { activityClaimDetail, activityClaimUpdateStatus, activityClaimUpdateVehicles } from "@/api/seek";
import { getNations } from "@/util/getNation";

export default {
  data() {
    return {
      dialogVisible: false,
      form: {
        rejectReason: "",
      },
      rules: {
        rejectReason: [
          {
            required: true,
            message: "驳回原因不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      detailData: {},
      previewFileList: [],
      mode: "",
      activeNames: ["base", "car", "operation"],
    };
  },
  computed: {
    vinCount() {
      return (this.detailData.vehicleList || []).length;
    },
    totalAmount() {
      const amount = this.detailData.activityAmount || 0;
      if ((amount * this.vinCount).toFixed(2) > 0) {
        return (amount * this.vinCount).toFixed(2);
      } else {
        return this.detailData.totalAmount;
      }
    },
  },
  created() {
    // 问题详情
    // this.problemData = getStorage("problemData");
    // // 修改导航跳转路径
    // if (sessionStorage.getItem('goBackPath')) {
    //   this.$route.meta.fatherPath = sessionStorage.getItem('goBackPath');
    // }
    //  this.$route.meta.fatherPath =
    // $(".breadcrumb > div > span:nth-child(2)").click(() => {
    //   this.$router.go(-1);
    // })
  },
  mounted() {
    this.mode = this.$route.query.mode || "";
    if (this.mode === "audit") {
      this.$route.meta.title = "审核";
    } else if (this.mode === "settlement") {
      this.$route.meta.title = "结算";
    } else {
      this.$route.meta.title = "查看详情"
    }
    const activityClaimId = this.$route.query.activityClaimId;
    if (activityClaimId) {
      this.getDetail(activityClaimId);
    }
  },
  methods: {
    async getDetail(activityClaimId) {
      const res = await activityClaimDetail({
        data: { activityClaimId: activityClaimId },
      });
      if (res.status == 0) {
        this.detailData = res.data || {};
      }
    },
    getCurrencyText(currency) {
      const currencyMap = {
        CNY: "人民币",
        USD: "美元",
        EUR: "欧元",
        GBP: "英镑",
      };
      return currencyMap[currency] || currency || "-";
    },
    getStatus(status) {
      const statusMap = {
        0: "草稿",
        1: "待审核",
        2: "已驳回",
        3: "待结算",
        4: "已结算",
        5: "已取消",
      };
      return statusMap[status] || "";
    },
    getCountryName(code) {
      if (!code) return "";
      return getNations(code);
    },
    formatTime(time) {
      if (!time) return "-";
      return time.replace("T", " ");
    },
    handleBack() {
      this.$router.go(-1);
    },
    // 保存车辆车型修改
    async saveVehicleModels() {
      const vehicles = (this.detailData.vehicleList || [])
        .filter(v => v.activityClaimVehicleId)
        .map(v => ({
          activityClaimVehicleId: v.activityClaimVehicleId,
          carModel: v.carModel
        }));
      if (vehicles.length === 0) return;
      await activityClaimUpdateVehicles({
        data: {
          activityClaimId: this.detailData.activityClaimId,
          vehicles: vehicles
        }
      });
    },
    async handleAuditPass() {
      try {
        await this.saveVehicleModels();
        const res = await activityClaimUpdateStatus({
          data: {
            activityClaimId: this.detailData.activityClaimId,
            status: 3, // 待结算
          },
        });
        if (res.status == 0) {
          this.$DonMessage.success("审核通过");
          this.$router.push("/kd-activityClaim");
        } else {
          this.$DonMessage.error(res.message || "操作失败");
        }
      } catch (error) {
        console.error(error);
      }
    },
    async handleAuditReject() {
      try {
        await this.saveVehicleModels();
        const res = await activityClaimUpdateStatus({
            data: {
              activityClaimId: this.detailData.activityClaimId,
              status: 2, // 已驳回
            },
          });
          if (res.status == 0) {
            this.$DonMessage.success("审核驳回");
            this.$router.push("/kd-activityClaim");
          } else {
            this.$DonMessage.error(res.message || "操作失败");
          }
        } catch (error) {
          console.error(error);
        }
    },
    // 驳回（弹窗提交）
    auditRejectSubmit() {
      this.$refs["rejectFormRef"].validate(async(valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        try {
          await this.saveVehicleModels();
          const res = await activityClaimUpdateStatus({
            data: {
              activityClaimId: this.detailData.activityClaimId,
              status: 2, // 已驳回
            },
          });
          if (res.status == 0) {
            this.$DonMessage.success("审核驳回");
            this.dialogVisible = false;
            this.$router.push("/kd-activityClaim");
          } else {
            this.$DonMessage.error(res.message || "操作失败");
          }
        } catch (error) {
          console.error(error);
        }
      });
    },
    async handleSettlement() {
      try {
        const res = await activityClaimUpdateStatus({
          data: {
            activityClaimId: this.detailData.activityClaimId,
            status: 4, // 已结算
          },
        });
        if (res.status == 0) {
          this.$DonMessage.success("结算成功");
          this.$router.push("/kd-activityClaim");
        } else {
          this.$DonMessage.error(res.message || "操作失败");
        }
      } catch (error) {
        console.error(error);
      }
    },
    // handlePreviewFile(fileList, index) {
    //   const imgExts = ["jpg", "jpeg", "png", "gif", "svg", "bmp"];
    //   const previewList = fileList.filter((file) => {
    //     const fileName = file.name || file.fileName || "";
    //     const ext = fileName.split(".").pop().toLowerCase();
    //     return imgExts.includes(ext);
    //   });
    //   if (previewList.length > 0) {
    //     this.previewFileList = previewList;
    //     const fileItem = fileList[index];
    //     this.$nextTick(() => {
    //       this.$refs.viewImgVideoRef.init(fileItem, previewList);
    //     });
    //   }
    // },
    // getFileIcon(file) {
    //   const fileName = file.name || file.fileName || "";
    //   const ext = fileName.split(".").pop().toLowerCase();
    //   const imgExts = ["jpg", "jpeg", "png", "gif", "svg", "bmp"];
    //   const videoExts = [
    //     "mp4",
    //     "avi",
    //     "mov",
    //     "wmv",
    //     "flv",
    //     "mkv",
    //     "3gp",
    //     "m4v",
    //   ];
    //   const docExts = ["doc", "docx", "pdf", "txt"];
    //   const xlsExts = ["xls", "xlsx"];
    //   const zipExts = ["zip", "rar", "7z"];

    //   if (imgExts.includes(ext)) {
    //     return file.url || file.filePath || "";
    //   } else if (videoExts.includes(ext)) {
    //     return require("@/assets/image/mp4.png");
    //   } else if (xlsExts.includes(ext)) {
    //     return require("@/assets/image/xls.png");
    //   } else if (docExts.includes(ext)) {
    //     return require("@/assets/image/doc.png");
    //   } else if (zipExts.includes(ext)) {
    //     return require("@/assets/image/zip.png");
    //   }
    //   return require("@/assets/image/fileIcon.png");
    // },
  },
};
</script>

<style src="@/assets/css/qualityStyle.css"></style>
<style src="@/components/problemDetails/problemDetail.css"></style>
<style lang="scss" scoped>
.total-row {
  font-size: 15px;
  margin-top: 15px;
  padding: 10px;
  background: var(--content-bgColor);
  font-weight: bold;
  color: #000;
}
.status0 {
  color: #909399;
}
.status1 {
  color: rgb(238, 149, 22);
}
.status2 {
  color: rgb(243, 72, 72);
}
.status3 {
  color: rgb(24, 144, 255);
}
.status4 {
  color: rgb(0, 136, 0);
}
.status5 {
  color: #909399;
}

</style>
